<template>
  <p>
    <img
      v-if="!hasErr"
      :src="url"
      alt=""
      @error="onError"
      @onload="onLoad"
      @click="handleClick"
    />
    <img v-else src="./../../assets/images/empty_data.png" alt="" />
  </p>
</template>
<script>
export default {
  props: {
    url: {
      type: String,
      default: ""
    },
    click: {
      type: Function,
      default: () => {},
      required: false
    },
    index: {
      type: Number,
      default: null,
      required: false
    },
    _index: {
      type: Number,
      default: null,
      required: false
    }
  },
  data() {
    return {
      hasErr: false
    };
  },
  methods: {
    onError(e) {
      this.hasErr = true;
    },

    onLoad(e) {
      this.hasErr = false;
    },

    handleClick() {
      this.index >= 0 && this.click && this.click(this.index, this._index);
    }
  }
};
</script>
<style lang="scss" scoped>
img {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  border-radius: 4px;
}
</style>
